/** Show inline validation error below a form field */
export function showFieldError(fieldId: string, message: string): void {
  clearFieldError(fieldId);
  const field = document.getElementById(fieldId);
  if (!field) return;
  field.classList.add('form-input-error');
  const errorEl = document.createElement('div');
  errorEl.className = 'form-error';
  errorEl.textContent = message;
  errorEl.id = `${fieldId}-error`;
  field.parentElement?.appendChild(errorEl);
}

/** Clear inline validation error for a field */
export function clearFieldError(fieldId: string): void {
  const field = document.getElementById(fieldId);
  if (field) field.classList.remove('form-input-error');
  const existing = document.getElementById(`${fieldId}-error`);
  if (existing) existing.remove();
}

/** Clear all form errors in a container */
export function clearAllErrors(container?: HTMLElement): void {
  const root = container ?? document;
  root.querySelectorAll('.form-error').forEach(el => el.remove());
  root.querySelectorAll('.form-input-error').forEach(el => el.classList.remove('form-input-error'));
}

/** Validate a required text field. Returns true if valid. */
export function validateRequired(fieldId: string, label: string): boolean {
  const field = document.getElementById(fieldId) as HTMLInputElement | HTMLTextAreaElement | null;
  if (!field) return false;
  const val = field.value.trim();
  if (!val) {
    showFieldError(fieldId, `${label} is required`);
    return false;
  }
  clearFieldError(fieldId);
  return true;
}

/** Validate email format (optional - only validates if non-empty) */
export function validateEmail(fieldId: string): boolean {
  const field = document.getElementById(fieldId) as HTMLInputElement | null;
  if (!field) return true;
  const val = field.value.trim();
  if (!val) return true;
  const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailPattern.test(val)) {
    showFieldError(fieldId, 'Invalid email format');
    return false;
  }
  clearFieldError(fieldId);
  return true;
}
